module.exports = __webpack_public_path__ + "assets/media/scissors-cut.8dc26b9f.svg";